import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { LiveEvent } from '../../Events/EventsDTO';
import Comments from '../../Comments/Comments';

interface CommentsPanelProps {
  liveEvent: LiveEvent;
}

export const CommentsPanel: React.FC<CommentsPanelProps> = ({
  liveEvent,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      flexGrow={1}
      overflow="auto"
      sx={{
        height: isMobile ? '100%' : 'calc(100vh - 200px)',
        padding: isMobile ? '8px 8px 8px 16px' : '16px 16px 16px 24px',
        boxSizing: 'border-box',
        backgroundColor: theme.palette.background.paper,
        borderRadius: isMobile ? 0 : 1,
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: theme.palette.background.default,
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.text.secondary,
          borderRadius: '3px',
          '&:hover': {
            backgroundColor: theme.palette.text.primary,
          },
        },
      }}
    >
      <Comments liveEvent={liveEvent} />
    </Box>
  );
};

export {};
